import type {
  GetFeaturesInnerParams,
  ModalProps,
} from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { getBaggage } from '@/app/components/search/components/Card/utils/featureUtils.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import dynamic from 'next/dynamic';

export const JourneyModalSearch = dynamic(() => import('../../../../../Modal/Modals/JourneyModalSearch'), {
  ssr: false,
});

export const getTransportFeatures = ({
  isDP,
  isHO,
  isTH,
  isOpx,
  dealCard,
  hasPreselectedFlightLink,
  isOverlay,
  t,
  isMobile,
  isLiveSearch,
  localization,
  adultsChildrenCount,
  originName,
  transportData,
}: GetFeaturesInnerParams): Feature[] => {
  if (isHO || !dealCard) return [];

  const transportIcon = {
    category: 'Transportation',
    name: isTH ? 'icon-train' : 'icon-airplane-right',
    color: 'iconPrimary',
  } as const;
  const isOriginAvailable = dealCard?.product?.geo?.origin && dealCard?.product?.geo?.origin !== 'XXX';
  const origin = isOriginAvailable && originName ? originName : '';
  const transport = dealCard?.product?.transport;
  const hasTransportLink = hasPreselectedFlightLink && transport?.transportId && !isOverlay;
  const hasTransfer = dealCard?.product?.rate?.offers?.transfer;
  const { small, hand, hold } = getBaggage({
    dealCard,
    transportData,
    t,
    localization,
    showFallback: true,
    adultsChildrenCount,
    isMobile,
    isOpx,
  });

  const trainsIncludedLabel =
    isOverlay || !origin
      ? t('vacation.oss.cards.trains.return_included')
      : t('vacation.oss.cards.trains.included', { origin });

  const flightsIncludedLabel =
    isOverlay || !origin
      ? t('vacation.oss.cards.flights.return_included')
      : t('vacation.oss.cards.flights.included', { origin });

  return [
    {
      icon: transportIcon,
      text: isTH ? trainsIncludedLabel : flightsIncludedLabel,
      featureType: hasTransportLink ? FeatureType.link : FeatureType.normal,
      className: 'included',
      ...(hasTransportLink
        ? {
            Modal: ({ isOpen, onClose }: ModalProps) => (
              <JourneyModalSearch isOpen={isOpen} onClose={onClose} dealCard={dealCard} />
            ),
          }
        : {}),
    },
    ...(isLiveSearch && isDP && !isOverlay
      ? [
          ...(small ? [small] : []),
          ...(hand ? [hand] : []),
          ...(hold ? [hold] : []),
          ...(hasTransfer
            ? [
                {
                  text: t('vacation.oss.cards.flights.transfer_included'),
                  featureType: FeatureType.normal,
                },
              ]
            : [
                {
                  icon: { category: 'UI Essentials', name: 'icon-bullet', color: 'iconPrimary' } as const,
                  text: t('vacation.oss.cards.flights.transfer_later'),
                  featureType: FeatureType.gray,
                },
              ]),
        ]
      : []),
  ];
};
